//export const API_URL = 'https://localhost:44395/api'
//export const API_URL = 'https://fng-portal-api-test.azurewebsites.net/api'
export const API_URL = 'https://fng-portal-api.azurewebsites.net/api'

export const STATE_LIST = [
  { id: "1", shortName: "GA", fullName: "GEORGIA" },
  { id: "2", shortName: "AL", fullName: "ALABAMA" },
  { id: "3", shortName: "AK", fullName: "ALASKA" },
  { id: "4", shortName: "AS", fullName: "AMERICAN SAMOA" },
  { id: "5", shortName: "AZ", fullName: "ARIZONA" },
  { id: "6", shortName: "AR", fullName: "ARKANSAS" },
  { id: "7", shortName: "CA", fullName: "CALIFORNIA" },
  { id: "8", shortName: "CO", fullName: "COLORADO" },
  { id: "9", shortName: "CT", fullName: "CONNECTICUT" },
  { id: "10", shortName: "DE", fullName: "DELAWARE" },
  { id: "11", shortName: "DC", fullName: "DISTRICT OF COLUMBIA" },
  { id: "12", shortName: "FM", fullName: "FEDERATED STATES OF MICRONESIA" },
  { id: "13", shortName: "FL", fullName: "FLORIDA" },
  { id: "14", shortName: "GU", fullName: "GUAM" },
  { id: "15", shortName: "HI", fullName: "HAWAII" },
  { id: "16", shortName: "ID", fullName: "IDAHO" },
  { id: "17", shortName: "IL", fullName: "ILLINOIS" },
  { id: "18", shortName: "IN", fullName: "INDIANA" },
  { id: "19", shortName: "KS", fullName: "KANSAS" },
  { id: "20", shortName: "KY", fullName: "KENTUCKY" },
  { id: "21", shortName: "LA", fullName: "LOUISIANA" },
  { id: "22", shortName: "ME", fullName: "MAINE" },
  { id: "23", shortName: "MH", fullName: "MARSHALL ISLANDS" },
  { id: "24", shortName: "MD", fullName: "MARYLAND" },
  { id: "25", shortName: "MA", fullName: "MASSACHUSETTS" },
  { id: "26", shortName: "MI", fullName: "MICHIGAN" },
  { id: "27", shortName: "MN", fullName: "MINNESOTA" },
  { id: "28", shortName: "MS", fullName: "MISSISSIPPI" },
  { id: "29", shortName: "MO", fullName: "MISSOURI" },
  { id: "30", shortName: "MT", fullName: "MONTANA" },
  { id: "31", shortName: "NE", fullName: "NEBRASKA" },
  { id: "32", shortName: "NV", fullName: "NEVADA" },
  { id: "33", shortName: "NH", fullName: "NEW HAMPSHIRE" },
  { id: "34", shortName: "NJ", fullName: "NEW JERSEY" },
  { id: "35", shortName: "NM", fullName: "NEW MEXICO" },
  { id: "36", shortName: "NY", fullName: "NEW YORK" },
  { id: "37", shortName: "NC", fullName: "NORTH CAROLINA" },
  { id: "38", shortName: "ND", fullName: "NORTH DAKOTA" },
  { id: "39", shortName: "MP", fullName: "NORTHERN MARIANA ISLANDS" },
  { id: "40", shortName: "OH", fullName: "OHIO" },
  { id: "41", shortName: "OK", fullName: "OKLAHOMA" },
  { id: "42", shortName: "OR", fullName: "OREGON" },
  { id: "43", shortName: "PW", fullName: "PALAU" },
  { id: "44", shortName: "PA", fullName: "PENNSYLVANIA" },
  { id: "45", shortName: "PR", fullName: "PUERTO RICO" },
  { id: "46", shortName: "RI", fullName: "RHODE ISLAND" },
  { id: "47", shortName: "SC", fullName: "SOUTH CAROLINA" },
  { id: "48", shortName: "SD", fullName: "SOUTH DAKOTA" },
  { id: "49", shortName: "TN", fullName: "TENNESSEE" },
  { id: "50", shortName: "TX", fullName: "TEXAS" },
  { id: "51", shortName: "UT", fullName: "UTAH" },
  { id: "52", shortName: "VT", fullName: "VERMONT" },
  { id: "53", shortName: "VI", fullName: "VIRIGIN ISLANDS" },
  { id: "54", shortName: "VA", fullName: "VIRGINIA" },
  { id: "55", shortName: "WA", fullName: "WASHINGTON" },
  { id: "56", shortName: "WV", fullName: "WEST VIRGINIA" },
  { id: "57", shortName: "WI", fullName: "WISCONSIN" },
  { id: "58", shortName: "WY", fullName: "WYOMING" },
  { id: "59", shortName: "AE", fullName: "ARMED FORCES AFRICA" },
  {
    id: "60",
    shortName: "AA",
    fullName: "ARMED FORCES AMERICAS (EXCEPT CANADA)",
  },
  { id: "61", shortName: "AE", fullName: "ARMED FORCES CANADA" },
  { id: "62", shortName: "AE", fullName: "ARMED FORCES EUROPE" },
  { id: "63", shortName: "AE", fullName: "ARMED FORCES MIDDLE EAST" },
  { id: "64", shortName: "AP", fullName: "ARMED FORCES PACIFIC" },
  { id: "65", shortName: "AB", fullName: "ALBERTA" },
  { id: "66", shortName: "BC", fullName: "BRITISH COLUMBIA" },
  { id: "67", shortName: "MB", fullName: "MANITOBA" },
  { id: "68", shortName: "NB", fullName: "NEW BRUNSWICK" },
  { id: "69", shortName: "NL", fullName: "NEWFOUNDLAND/LABRADOR" },
  { id: "70", shortName: "NT", fullName: "NORTHWEST TERRITORIES" },
  { id: "71", shortName: "NS", fullName: "NOVA SCOTIA" },
  { id: "72", shortName: "NU", fullName: "NUNAVUT" },
  { id: "73", shortName: "ON", fullName: "ONTARIO" },
  { id: "74", shortName: "PE", fullName: "PRINCE EDWARD ISLAND" },
  { id: "75", shortName: "QC", fullName: "QUEBEC" },
  { id: "76", shortName: "SK", fullName: "SASKATCHEWAN" },
  { id: "77", shortName: "YT", fullName: "YUKON" },
  { id: "78", shortName: "IA", fullName: "IOWA" },
];


export const RENEW_RATE_PLAN_LIST = [
  { id: 1, text: "12 months" },
  { id: 2, text: "24 months" },
  { id: 3, text: "36 months" },
  { id: 4, text: "Variable" },
  { id: 5, text: "Other" },
];

export const PAGINATION_LIST = [
  { value: 10, text: "10 per page" },
  { value: 25, text: "25 per page" },
  { value: 50, text: "50 per page" },
];

